import { ContextMenuContext } from '@components/organisms/navbar/ContextMenuContext';
import { HamburgerMenuContext } from '@components/organisms/navbar/HamburgerMenuContext';
import { useContext } from 'react';
import { Link, useNavigate } from 'react-router';

interface ContextMenuBaseProps {
    leftIcon: React.ReactNode;
    label: string;
    to: string;
    onClick?: () => void;
    id?: string;
    cy?: string;
}

const ContextMenuBase = ({
    leftIcon,
    label,
    to,
    onClick,
    id,
    cy,
}: ContextMenuBaseProps) => {
    const navigate = useNavigate();
    const { setIsOpen } = useContext(HamburgerMenuContext);
    const { setIsOpen: setContextMenuIsOpen } = useContext(ContextMenuContext);

    return (
        <li className="Label-Medium lg:font-normal font-semibold flex w-full">
            <Link
                to={to}
                className="flex gap-x-4 items-center w-full flex-1"
                onClick={e => {
                    e.preventDefault();
                    setIsOpen(false);
                    setContextMenuIsOpen(false);
                    navigate(to);
                    onClick && onClick();
                }}
                id={id}
                data-cy={cy}
            >
                {leftIcon}
                {label}
            </Link>
        </li>
    );
};

export default ContextMenuBase;
